import React from "react";

import nary from "@/modules/nary";
import { assetImg } from "@/modules/moduleImporter";
import { ILongerGameStatisticsProps } from "@/types/LongerStatisticsTypes";

import "@/styles/machine_game_statistics.scss";

//Unusual component: doesn't follow the GameStatistics standards
export default class M29 extends React.Component<ILongerGameStatisticsProps> {
	render() {
		const animals = [
			"rat", "horse",
			"ox", "goat",
			"tiger", "monkey",
			"rabbit", "rooster",
			"dragon", "dog",
			"snake", "pig"
		];
		
		const output = {};
		animals.forEach(animal => output[animal] = 0);
		this.props.history.map(item => item.angka.split(","))
			.forEach(item => item.forEach(subItem => output[subItem]++));
		
		const total = this.props.history.length * 3;
		
		// console.log("Props on GS m29", this.props);
		
		return <div className="game-statistics machine-game-statistics m29-statistics">
		{
			nary(6).map((_num, idx) =>
				<div className="row" key={"GS_m29_" + idx}>
					<div>
						{ assetImg("m29", animals[idx * 2] + ".svg") }
						<div>
						{ Math.round(output[animals[idx * 2]] / total * 100) } %
						</div>
					</div>
					
					<div>
						{ assetImg("m29", animals[idx * 2 + 1] + ".svg") }
						<div>
						{ Math.round(output[animals[idx * 2 + 1]] / total * 100) } %
						</div>
					</div>
				</div>
			)
		}
		</div>;
	}
}